const c = {
  BR: "BRL"
};
export {
  c as currencyLocale
};
